import React, { Fragment, useContext } from 'react'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import { AppContext } from '../../App'
import { useNavigate } from 'react-router-dom'
import { BaseUrl as getBlobBaseUrl } from '../../utility/BaseUrl'
import { AppDataList } from './HomePage'
import { isValidJson } from '../../utility/Utility'
import { Header } from '../../css/Style'

const FeaturedCards = styled.div`
margin-top: 20px;
display: -webkit-box;
display: -ms-flexbox;
overflow: scroll hidden;
white-space: nowrap;
@media (min-width: 0px) and (max-width: 420px){
  margin-top: 16px;
  width: 357.16px;
  height: 177.17px;
}
`
const CardTitle = styled.div`
font-family: "AeonikPro-Medium";
font-style: normal;
font-weight: 500;
font-size: 20px;
line-height: 26px;
width: 178px;
height: 52px;
white-space: break-spaces;
color: #25233B;
display: -webkit-box;
text-overflow: ellipsis;
white-space: initial;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
overflow: hidden;
@media (min-width: 0px) and (max-width: 900px){
  font-size: 13.9px;
  line-height: 18.08px;
  width: 137.65px;
  height: 37px;
}
`

const CardDescription = styled.div`
margin-top: 8px;
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 18px;
height: 54px;
width: 178px;
color: #25233B;
display: -webkit-box;
text-overflow: ellipsis;
white-space: initial;
-webkit-line-clamp: 3;
-webkit-box-orient: vertical;
overflow: hidden;
@media (min-width: 0px) and (max-width: 450px){
  font-size: 8.34px;
  line-height: 12.51px;
  width: 123.75px;
  height: 38px;
}
`
const ButtonContainer = styled.div`
position: absolute;
bottom: 10px; 
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
gap: 5.31px;

width: 178px;
height: 32px;                                                                                                                                                                                                                                                                                                                                                                                                                   

background: #E5E5E5;
border-radius: 4px;

flex: none;
order: 1;
align-self: stretch;
flex-grow: 0;
@media (min-width: 0px) and (max-width: 450px){
  width: 123.75px;
  height: 22.25px;    
}

`

const ButtonText = styled.div`
font-family: "AeonikPro-Medium";
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 18px;
color: #35324A;
`
const FetText = styled.div`
/* Auto layout */

display: flex;
flex-direction: column;
align-items: flex-start;
padding-top: 10px;
padding-left: 10px;
top: 16px;
left: 20px;
position: absolute;
width: 198px;
height: 194px;
background: #FFFFFF;
border-radius: 8px;
@media (min-width: 0px) and (max-width: 450px){
  width: 137.65px;
  height: 123.18px;
  padding-top: 6.95px;
  padding-left: 6.95px;
}

`

interface IProps{
    featuredApps: AppDataList[] | undefined
  }

const FeaturedApp = (props :IProps) => {
  const { setCurrentApp } = useContext(AppContext)
  const navigate = useNavigate()

  function routeToDetail (id: string) {
    setCurrentApp(id)
    navigate('/details/' + id)
  }

  const getImagePath = (file : string) => {
    return file && isValidJson(file) ? JSON.parse(file).path : file
  }

  return (
      <Fragment>
        <Header> Featured </Header>
          <FeaturedCards>
            {
              props.featuredApps && props.featuredApps.map((featuredApp) => {
                return <Card
                  key={featuredApp.appId}
                  variant="outlined" sx={{
                    overflow: 'initial',
                    marginLeft: '-12px',
                    width: '437.5px',
                    height: '216px',
                    background: `url(https://${getBlobBaseUrl()}${getImagePath(featuredApp.featureImage)})`,
                    backgroundSize: 'contain',
                    borderRadius: '8px',
                    marginRight: '15.5px',
                    border: 'none',
                    position: 'relative',
                    padding: '10px',
                    '@media (min-width: 0px) and (max-width: 450px)': {
                      width: '304.16px',
                      marginLeft: '-8px',
                      marginRight: '4px',
                      height: '150.17px'
                    }
                  }
            }>
            <FetText>
              <CardTitle>
                {featuredApp.name}
              </CardTitle>
              <CardDescription>
                {featuredApp.description}
              </CardDescription>
              <ButtonContainer onClick={() => { routeToDetail(featuredApp.appId) }}>
                <Button
                sx={{ width: '156px', height: '27px', background: '#E5E5E5', boxShadow: 'none', ':hover': { background: '#E5E5E5', boxShadow: 'none' } }} variant="contained">
                <ButtonText>
                    Learn More
                </ButtonText>
                </Button>
              </ButtonContainer>
            </FetText>
        </Card>
              })
        }
        </FeaturedCards>
    </Fragment>
  )
}

export default FeaturedApp
